import { RouteEntry } from "../../shared/routes";
import { RedirectToLink } from "./RedirectToLink";


export const linkRoutes: Array<RouteEntry> = [
    { path: '/link/to/:url', element: <RedirectToLink />, authorize: false },
];